import getVisibilityState from './visibility-state';
import getLoadedStatus from './loaded-status';

export default {
  getVisibilityState,
  getLoadedStatus,
};
